export default __webpack_public_path__ + "static/media/macBanner.95bd8ca9.webp";